var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "new-broadcast-form" },
    [
      _c(
        "a-steps",
        {
          style: _vm.stepStyle,
          attrs: { type: "navigation", size: "small" },
          model: {
            value: _vm.current,
            callback: function ($$v) {
              _vm.current = $$v
            },
            expression: "current",
          },
        },
        [
          _c("a-step", {
            attrs: {
              title: _vm.$t("wp.broadcast.detail"),
              description: _vm.$t("wp.broadcastTitle"),
              status: _vm.current === 0 ? "process" : "wait",
            },
          }),
          _vm._v(" "),
          _c("a-step", {
            attrs: {
              title: _vm.$t("wp.recipients"),
              description: _vm.$t("wp.selectRecipients"),
              status: _vm.current === 1 ? "process" : "wait",
            },
          }),
          _vm._v(" "),
          _c("a-step", {
            attrs: {
              title: _vm.$t("wp.messages"),
              description: _vm.$t("wp.writeYourMessage"),
              status: _vm.current === 2 ? "process" : "wait",
            },
          }),
          _vm._v(" "),
          _vm.showMmliteStep
            ? _c("a-step", {
                attrs: {
                  title: _vm.$t(
                    "whatsapp_business_api.mmLiteBroadcastSectionTitle"
                  ),
                  description: _vm.$t(
                    "whatsapp_business_api.mmLiteBroadcastSectionLead"
                  ),
                  status: _vm.current === 3 ? "process" : "wait",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("a-step", {
            attrs: {
              title: _vm.$t("wp.schedule"),
              description: _vm.$t("wp.scheduleNowOrLater"),
              status:
                _vm.current === _vm.scheduleStepIndex ? "process" : "wait",
            },
          }),
          _vm._v(" "),
          _c("a-step", {
            attrs: {
              title: _vm.$t("wp.summary"),
              description: _vm.$t("wp.summary"),
              status: _vm.current === _vm.summaryStepIndex ? "process" : "wait",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.current === 0
        ? _c(
            "div",
            [
              _c(
                "md-field",
                [
                  _c("label", [_vm._v(_vm._s(_vm.$t("wp.title")))]),
                  _vm._v(" "),
                  _c("md-input", {
                    attrs: { required: "" },
                    model: {
                      value: _vm.model.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "title", $$v)
                      },
                      expression: "model.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-field",
                [
                  _c("label", [_vm._v(_vm._s(_vm.$t("wp.description")))]),
                  _vm._v(" "),
                  _c("md-textarea", {
                    attrs: { required: "" },
                    model: {
                      value: _vm.model.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "description", $$v)
                      },
                      expression: "model.description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.current === 1
        ? _c(
            "div",
            [
              _c("RecipientSelect", {
                attrs: { "contact-list": _vm.contacts, channel: _vm.channel },
                model: {
                  value: _vm.model,
                  callback: function ($$v) {
                    _vm.model = $$v
                  },
                  expression: "model",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.current === 2
        ? _c(
            "div",
            [
              _vm.isMetaWabaChannel
                ? _c("MetaTemplateMessageSelector", {
                    attrs: { channel: _vm.channel },
                    model: {
                      value: _vm.model,
                      callback: function ($$v) {
                        _vm.model = $$v
                      },
                      expression: "model",
                    },
                  })
                : _vm.isWhatsappBusinessChannel
                ? _c("TemplateMessageSelector", {
                    attrs: { "channel-id": _vm.channelId },
                    model: {
                      value: _vm.model,
                      callback: function ($$v) {
                        _vm.model = $$v
                      },
                      expression: "model",
                    },
                  })
                : _c("MessageEditor", {
                    attrs: { attributes: _vm.getAttributes() },
                    model: {
                      value: _vm.model.messages,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "messages", $$v)
                      },
                      expression: "model.messages",
                    },
                  }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.current === 3 && _vm.showMmliteStep
        ? _c("div", { staticClass: "broadcast-mmlite-step" }, [
            _c("div", { staticClass: "mmlite-broadcast-block" }, [
              _c("div", { staticClass: "mmlite-broadcast-header" }, [
                _c("h4", { staticClass: "mmlite-broadcast-heading" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "whatsapp_business_api.mmLiteBroadcastSectionTitle"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "mmlite-broadcast-lead" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("whatsapp_business_api.mmLiteBroadcastSectionLead")
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "mmlite-broadcast-cards",
                  attrs: {
                    role: "radiogroup",
                    "aria-label": _vm.$t(
                      "whatsapp_business_api.mmLiteBroadcastSectionTitle"
                    ),
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "mmlite-broadcast-card mmlite-broadcast-card--with-badge",
                      class: {
                        "mmlite-broadcast-card--active":
                          _vm.model.sendTemplateViaMmlite !== false,
                      },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.model.sendTemplateViaMmlite = true
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "mmlite-broadcast-card-badge" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "whatsapp_business_api.mmLiteBroadcastBadgeRecommended"
                              )
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "mmlite-broadcast-card-title" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "whatsapp_business_api.mmLiteBroadcastOptionRecommendedTitle"
                              )
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "mmlite-broadcast-card-text" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "whatsapp_business_api.mmLiteBroadcastOptionRecommendedBody"
                              )
                            )
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "mmlite-broadcast-card",
                      class: {
                        "mmlite-broadcast-card--active":
                          _vm.model.sendTemplateViaMmlite === false,
                      },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.model.sendTemplateViaMmlite = false
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "mmlite-broadcast-card-title" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "whatsapp_business_api.mmLiteBroadcastOptionStandardTitle"
                              )
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "mmlite-broadcast-card-text" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "whatsapp_business_api.mmLiteBroadcastOptionStandardBody"
                              )
                            )
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.current === _vm.scheduleStepIndex
        ? _c(
            "div",
            [
              _c("TimeSelect", {
                model: {
                  value: _vm.model,
                  callback: function ($$v) {
                    _vm.model = $$v
                  },
                  expression: "model",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.current === _vm.summaryStepIndex
        ? _c(
            "div",
            [
              _c("Summary", {
                attrs: {
                  model: _vm.model,
                  contacts: _vm.contacts,
                  loading: _vm.loading,
                  submit: _vm.submit,
                  cancel: _vm.cancel,
                  channel: _vm.channel,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("a-divider", { staticClass: "=mt-5" }),
      _vm._v(" "),
      _c("div", { staticClass: "navs" }, [
        _c(
          "div",
          [
            _vm.current > 0
              ? _c(
                  "md-button",
                  {
                    staticClass: "md-raised md-primary",
                    on: { click: _vm.goPrev },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-center px-3",
                      },
                      [
                        _c("span", { staticClass: "material-icons mr-3" }, [
                          _vm._v(" arrow_back "),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.prevStepLabel))]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "md-button",
              {
                staticClass: "md-raised md-secondary",
                on: { click: _vm.cancel },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-center px-3",
                  },
                  [_vm._v(_vm._s(_vm.$t("wp.cancel")))]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.current < _vm.summaryStepIndex
              ? _c(
                  "md-button",
                  {
                    staticClass: "md-raised md-primary",
                    on: { click: _vm.goNext },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-center px-3",
                      },
                      [
                        _c("span", { staticClass: "material-icons mr-3" }, [
                          _vm._v(" arrow_forward "),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.nextStepLabel))]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.current === _vm.summaryStepIndex
              ? _c(
                  "md-button",
                  {
                    staticClass: "md-raised md-primary",
                    attrs: { disabled: _vm.loading },
                    on: { click: _vm.submit },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-center px-3",
                      },
                      [
                        _c("span", { staticClass: "material-icons mr-3" }, [
                          _vm._v(" send "),
                        ]),
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.loading
                                ? _vm.$t("wp.sending")
                                : _vm.$t("wp.send")
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }